import { type UseQueryResult, useQuery } from 'react-query';
import {
  DashboardService,
  // eslint-disable-next-line camelcase
  type Wealthlane_AwardService_Dtos_ParticipantTask_UpComingEventsResponseDto,
} from '../../services/wealthlane-award-services';

const useGetParticipantDashboardUpcomingEventSummary = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
  //   isOnBoarded?: boolean
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_AwardService_Dtos_ParticipantTask_UpComingEventsResponseDto | undefined,
  unknown
> => {
  const participantDashboardUpcomingEventSummary = useQuery(
    ['getParticipantDashboardUpcomingEventSummary'],
    async () => {
      //   if (isOnBoarded) {
      return await handleRequest(
        DashboardService.getApiAwardApiAppDashboardParticipantUpcomingEventsSummary()
      );
    }
    // }
  );
  return participantDashboardUpcomingEventSummary;
};

export default useGetParticipantDashboardUpcomingEventSummary;
